/* Squad18 Neo-Manga theme scripts */
(function () {
  'use strict';
  const S = window.S18 || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = S.moneyFormat || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const group = (num, dec, thou, sep) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    });
  }
  S.formatMoney = formatMoney;

  const announce = (msg) => { const el = $('#s18-announce'); if (el) { el.textContent = ''; setTimeout(() => (el.textContent = msg), 50); } };

  /* ---------- free shipping helper ---------- */
  // `base` is what's already in the cart; when `total` also includes the item on screen, the copy says "Add this".
  function shipMsg(total, textEl, fillEl, base) {
    if (!textEl || !fillEl || !S.freeShip) return;
    const left = S.freeShip - total;
    const projected = base !== undefined;
    if (projected && base >= S.freeShip) textEl.innerHTML = '<strong>You unlocked free worldwide shipping!</strong>';
    else if (left > 0) textEl.innerHTML = `${projected ? 'Add this and you\'re' : 'You\'re'} <strong>${formatMoney(left)}</strong> away from free worldwide shipping`;
    else textEl.innerHTML = projected ? '<strong>Add this to unlock free worldwide shipping!</strong>' : '<strong>You unlocked free worldwide shipping!</strong>';
    fillEl.style.width = Math.min(100, (total / S.freeShip) * 100) + '%';
    fillEl.classList.toggle('full', left <= 0);
  }

  /* ---------- drawers (cart + mobile menu) ---------- */
  const scrim = $('#s18-scrim');
  let openDrawerEl = null, lastFocus = null;
  function openDrawer(el, trigger) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(false);
    lastFocus = trigger || document.activeElement;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    document.body.style.overflow = 'hidden';
    openDrawerEl = el;
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const f = $('[data-close]', el); f && f.focus();
  }
  function closeDrawer(restore = true) {
    if (!openDrawerEl) return;
    const el = openDrawerEl;
    el.classList.remove('on'); el.setAttribute('aria-hidden', 'true');
    scrim && scrim.classList.remove('on');
    document.body.style.overflow = '';
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openDrawerEl = null;
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      const target = document.getElementById(opener.getAttribute('aria-controls'));
      if (target) { e.preventDefault(); openDrawer(target, opener); if (target.id === 's18-cart') Cart.refresh(); }
      return;
    }
    if (e.target.closest('[data-close]') || e.target === scrim) closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') return closeDrawer();
    if (e.key === 'Tab') {
      const f = $$('a[href],button:not([disabled]),input,select,textarea', openDrawerEl).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- cart ---------- */
  const Cart = {
    state: null,
    async fetch() {
      const r = await fetch(S.routes.cart, { headers: { Accept: 'application/json' } });
      this.state = await r.json();
      return this.state;
    },
    async refresh() {
      try { await this.fetch(); this.render(); } catch (e) { /* keep server-rendered state */ }
    },
    async add(items) {
      const r = await fetch(S.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      await this.refresh();
      return data;
    },
    async change(line, quantity) {
      const drawer = $('#s18-cart');
      drawer && drawer.classList.add('busy');
      try {
        const r = await fetch(S.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        this.state = await r.json();
        this.render();
      } finally { drawer && drawer.classList.remove('busy'); }
    },
    render() {
      const c = this.state; if (!c) return;
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = c.item_count;
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
      $$('[data-cart-label]').forEach((el) => el.setAttribute('aria-label', `Open cart, ${c.item_count} item${c.item_count === 1 ? '' : 's'}`));
      const items = $('#s18-cart-items');
      if (items) {
        items.innerHTML = c.items.length ? c.items.map((it, i) => {
          const img = it.image ? `<img src="${esc(it.image + (it.image.includes('?') ? '&' : '?') + 'width=160')}" alt="" width="64" height="64" loading="lazy">` : '<span></span>';
          const variant = it.variant_title && !/Default Title/.test(it.variant_title) ? `<small>${esc(it.variant_title)}</small>` : '';
          return `<div class="line">${img}<div><a href="${esc(it.url)}">${esc(it.product_title)}</a>${variant}
            <div class="mini-qty" role="group" aria-label="Quantity for ${esc(it.product_title)}">
              <button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="${it.quantity === 1 ? 'Remove' : 'Decrease'} ${esc(it.product_title)}">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase ${esc(it.product_title)}">+</button>
            </div></div><b>${formatMoney(it.final_line_price)}</b></div>`;
        }).join('') : '<p class="empty">Your cart is empty. Go find your arc.</p>';
      }
      const sub = $('#s18-cart-sub'); sub && (sub.textContent = formatMoney(c.total_price));
      shipMsg(c.total_price, $('#s18-cart-ship'), $('#s18-cart-bar'));
      const checkout = $('#s18-cart-checkout'); checkout && checkout.toggleAttribute('hidden', !c.item_count);
      document.dispatchEvent(new CustomEvent('s18:cart', { detail: c }));
    }
  };
  window.S18.Cart = Cart;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('#s18-cart-items [data-line]');
    if (b) Cart.change(Number(b.dataset.line), Math.max(0, Number(b.dataset.qty))).then(() => announce('Cart updated'));
  });

  /* add-to-cart buttons: shared loading/done UI */
  async function runAdd(btn, items, name) {
    if (!btn || btn.classList.contains('loading')) return;
    const label = btn.innerHTML;
    btn.classList.add('loading'); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
    const errEl = btn.closest('form') && $('[data-form-error]', btn.closest('form'));
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    try {
      await Cart.add(items);
      btn.classList.remove('loading'); btn.classList.add('done'); btn.textContent = 'Added ✓';
      announce((name || 'Item') + ' added to cart');
      openDrawer($('#s18-cart'), btn);
    } catch (err) {
      btn.classList.remove('loading');
      if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else { announce(err.message); }
    } finally {
      btn.removeAttribute('aria-busy');
      setTimeout(() => { btn.classList.remove('done'); btn.innerHTML = label; document.dispatchEvent(new Event('s18:product-change')); }, 1400);
    }
  }

  /* quick add on product cards */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-quick-add]');
    if (!f) return;
    e.preventDefault();
    runAdd($('button[type=submit]', f), [{ id: Number(f.elements.id.value), quantity: 1 }], f.dataset.title);
  });

  /* ---------- product page ---------- */
  function initProduct(root) {
    const form = $('form[data-product-form]', root);
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    const dataEl = $('[data-product-json]', root);
    const product = dataEl ? JSON.parse(dataEl.textContent) : null;
    const idInput = form.elements.id;
    const qtyInput = $('[data-qty-input]', root);
    const addBtn = $('[data-add]', root);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), saveEl = $('[data-save]', root), btnPrice = () => $('[data-btn-price]', root);
    const stickyBtn = $('[data-sticky-add]', root), sticky = $('[data-sticky]', root);
    let variant = product && product.variants.find((v) => v.id === Number(idInput.value));

    const kitPrice = () => { const k = $('input[name="s18-kit"]:checked', root); return k && k.value ? Number(k.dataset.price) : 0; };
    const qty = () => Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    function update() {
      if (!variant) return;
      const total = variant.price * qty() + kitPrice();
      const bp = btnPrice(); bp && (bp.textContent = formatMoney(total));
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        const on = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !on; if (saveEl) saveEl.hidden = !on;
        if (on) {
          $('[data-compare-amount]', compareEl).textContent = formatMoney(variant.compare_at_price);
          if (saveEl) saveEl.textContent = 'SAVE ' + formatMoney(variant.compare_at_price - variant.price);
        }
      }
      const cartTotal = Cart.state ? Cart.state.total_price : 0;
      shipMsg(cartTotal + total, $('[data-ship-text]', root), $('[data-ship-fill]', root), cartTotal);
      const avail = variant.available;
      [addBtn, stickyBtn].forEach((b) => { if (b && !b.classList.contains('loading') && !b.classList.contains('done')) { b.disabled = !avail; } });
      if (!avail && addBtn && !addBtn.classList.contains('done')) addBtn.textContent = 'Sold out';
      else if (avail && addBtn && !btnPrice() && !addBtn.classList.contains('loading') && !addBtn.classList.contains('done')) addBtn.innerHTML = 'Add to cart · <span data-btn-price>' + formatMoney(total) + '</span>';
      const sp = $('[data-sticky-price]', root); sp && (sp.textContent = formatMoney(variant.price));
      const minus = $('[data-qty-minus]', root); minus && (minus.disabled = qty() <= 1);
    }

    $$('[data-option]', root).forEach((sel) => sel.addEventListener('change', () => {
      const chosen = $$('[data-option]', root).map((s) => s.value);
      variant = product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (variant) {
        idInput.value = variant.id;
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
        if (variant.featured_media) {
          const t = $(`[data-media-id="${variant.featured_media.id}"]`, root); t && t.click();
        }
      } else if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      update();
    }));
    $('[data-qty-minus]', root) && $('[data-qty-minus]', root).addEventListener('click', () => { qtyInput.value = Math.max(1, qty() - 1); update(); });
    $('[data-qty-plus]', root) && $('[data-qty-plus]', root).addEventListener('click', () => { qtyInput.value = Math.min(99, qty() + 1); update(); });
    qtyInput && qtyInput.addEventListener('change', update);
    $$('input[name="s18-kit"]', root).forEach((r) => r.addEventListener('change', update));
    document.addEventListener('s18:cart', update);
    document.addEventListener('s18:product-change', update);

    function submit(btn) {
      if (!variant) return;
      const items = [{ id: variant.id, quantity: qty() }];
      const k = $('input[name="s18-kit"]:checked', root);
      if (k && k.value) items.push({ id: Number(k.value), quantity: 1 });
      runAdd(btn, items, product.title);
    }
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(addBtn); });
    stickyBtn && stickyBtn.addEventListener('click', () => submit(stickyBtn));

    // gallery
    const thumbs = $$('.thumb', root);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      thumbs.forEach((x) => x.setAttribute('aria-pressed', String(x === t)));
      $$('.view', root).forEach((v) => v.classList.toggle('on', v.dataset.v === t.dataset.view));
    }));

    // sticky bar
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn && (stickyBtn.tabIndex = show ? 0 : -1);
      }).observe(addBtn);
    }
    update();
  }

  /* ---------- tabs ---------- */
  function initTabs(root) {
    $$('[role=tablist]', root).forEach((list) => {
      const tabs = $$('[role=tab]', list);
      const select = (b, focus) => {
        tabs.forEach((t) => {
          const on = t === b;
          t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
          const p = document.getElementById(t.getAttribute('aria-controls')); p && (p.hidden = !on);
        });
        const more = list.closest('section') && $('[data-tab-more]', list.closest('section'));
        if (more && b.dataset.url) { more.href = b.dataset.url; more.firstChild.textContent = b.dataset.more + ' '; }
        focus && b.focus();
      };
      tabs.forEach((b, i) => {
        b.addEventListener('click', () => select(b));
        b.addEventListener('keydown', (e) => {
          const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  /* ---------- reveal ---------- */
  function initReveal(root) {
    const els = $$('.reveal:not(.in)', root);
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) { els.forEach((el) => el.classList.add('in')); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- delivery estimate ---------- */
  function initEta(root) {
    $$('[data-eta]', root).forEach((el) => {
      const [a, b] = el.dataset.eta.split(',').map(Number);
      const fmt = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      el.textContent = fmt(a) + ' – ' + fmt(b);
    });
  }

  /* ---------- cart page qty buttons ---------- */
  function initCartPage(root) {
    $$('[data-cart-qty]', root).forEach((wrap) => {
      const input = $('input', wrap);
      $$('button', wrap).forEach((b) => b.addEventListener('click', () => {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.dataset.step));
        input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
      }));
    });
  }

  function init(root = document) {
    initTabs(root); initReveal(root); initEta(root); initCartPage(root);
    $$('[data-product-section]', root).forEach(initProduct);
  }

  document.documentElement.classList.remove('no-js');
  init();
  Cart.refresh();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
